<div>
    <h6 #header1 class="ap-green mt-1">{{header}}</h6>
    <div>
        <dx-data-grid #opportunitiesGrid style="width: 100%" [dataSource]="opportunities" [columnAutoWidth]="true"
            [allowColumnReordering]="true" [wordWrapEnabled]="false" showBorders="true">
            <dxo-toolbar>
                <dxi-item name="groupPanel"></dxi-item>
                <dxi-item location="after">
                    <dx-button icon="exportxlsx" class="ap-blue-btn" (onClick)="exportExcel($event)"
                        text="Export to Excel">
                    </dx-button>
                </dxi-item>
                <dxi-item name="searchPanel"></dxi-item>
            </dxo-toolbar>
            <dxo-column-fixing [enabled]="true"></dxo-column-fixing>
            <dxo-header-filter [visible]="true"></dxo-header-filter>
            <dxo-search-panel [visible]="true"></dxo-search-panel>
            <dxo-paging [pageSize]="10"></dxo-paging>
            <dxo-sorting mode="multiple"></dxo-sorting>
            <dxo-export [enabled]="true"></dxo-export>
            <dxi-column dataField="accountNum" cssClass="column-group-sub-header" caption="Account Num"></dxi-column>
            <dxi-column dataField="opportunityID" cssClass="column-group-sub-header"
                caption="Opportunity ID"></dxi-column>
            <dxi-column cssClass="column-group-sub-header" dataField="oppStatus" caption="Opp Status"></dxi-column>
            <dxi-column cssClass="column-group-sub-header" dataField="salesStage" caption="Sales Stage"></dxi-column>
            <dxi-column cssClass="column-group-sub-header" dataField="salesStagePct"
                caption="Sales Stage Pct"></dxi-column>
            <dxi-column cssClass="column-group-sub-header" dataField="businessType"
                caption="Business Type"></dxi-column>
            <dxi-column cssClass="column-group-sub-header" dataField="opportunityType"
                caption="Opportunity Type"></dxi-column>
            <dxi-column cssClass="column-group-sub-header" dataField="opType" caption="Op Type"></dxi-column>
            <dxi-column cssClass="column-group-sub-header" dataField="createdDate" caption="Created Date"></dxi-column>
            <dxi-column cssClass="column-group-sub-header" dataField="closingDate" caption="Closing Date"></dxi-column>
            <dxi-column cssClass="column-group-sub-header" dataField="onstreamDate"
                caption="Onstream Date"></dxi-column>
            <dxi-column cssClass="column-group-sub-header" dataField="reason" caption="Reason"></dxi-column>
            <dxi-column cssClass="column-group-sub-header" dataField="competitor" caption="Competitor"></dxi-column>
            <dxi-column cssClass="column-group-sub-header" dataField="itemNum" caption="Item Number"></dxi-column>
            <dxi-column cssClass="column-group-sub-header" dataField="product" caption="Product"></dxi-column>
            <dxi-column cssClass="column-group-sub-header" dataField="unitPrice" caption="Unit Price"></dxi-column>
            <dxi-column cssClass="column-group-sub-header" dataField="annualQuantity"
                caption="Annual Quantity"></dxi-column>
            <dxi-column cssClass="column-group-sub-header" dataField="qtyUnit" caption="Qty Unit"></dxi-column>
            <dxi-column cssClass="column-group-sub-header" dataField="expTotalValue"
                caption="Exp Total Value"></dxi-column>
            <dxi-column cssClass="column-group-sub-header" dataField="mtd" caption="MTD"></dxi-column>
            <dxi-column cssClass="column-group-sub-header" dataField="prodHierLevel3"
                caption="Prod Hier Level3"></dxi-column>
            <dxi-column cssClass="column-group-sub-header" dataField="description" caption="Description"></dxi-column>
            <dxi-column cssClass="column-group-sub-header" dataField="territory"
                caption="Territory from Zip"></dxi-column>
            <dxi-column cssClass="column-group-sub-header" dataField="crmTerritory"
                caption="Territory from CRM"></dxi-column>
            <dxi-column cssClass="column-group-sub-header" dataField="isFAMKAM" caption="Is FAM/KAM"></dxi-column>
            <dxi-column cssClass="column-group-sub-header" dataField="company" caption="Company"></dxi-column>
            <dxi-column cssClass="column-group-sub-header" dataField="streeT60" caption="Street Address"></dxi-column>
            <dxi-column cssClass="column-group-sub-header" dataField="citY_1" caption="CITY1"></dxi-column>
            <dxi-column cssClass="column-group-sub-header" dataField="region" caption="REGION"></dxi-column>
            <dxi-column cssClass="column-group-sub-header" dataField="postalcode" caption="Postal Code"></dxi-column>
            <dxi-column cssClass="column-group-sub-header" dataField="country" caption="Country"></dxi-column>
            <dxi-column cssClass="column-group-sub-header" dataField="globalIndustrySegment"
                caption="Global Industry Segment"></dxi-column>
            <dxi-column cssClass="column-group-sub-header" dataField="maMarketSegment"
                caption="MA Market Segment"></dxi-column>
            <dxi-column cssClass="column-group-sub-header" dataField="majorSegment"
                caption="Major Segment"></dxi-column>
            <dxi-column cssClass="column-group-sub-header" dataField="apIndustrySegment"
                caption="AP Industry Segment"></dxi-column>
            <dxi-column cssClass="column-group-sub-header" dataField="marketSegment"
                caption="Market Segment"></dxi-column>
            <dxi-column cssClass="column-group-sub-header" dataField="apTechnologyOffering"
                caption="AP Technology Offering"></dxi-column>
            <dxi-column cssClass="column-group-sub-header" dataField="contractExpireDate"
                caption="Contract Expire Date"></dxi-column>
            <dxi-column cssClass="column-group-sub-header" dataField="supplierName"
                caption="Supplier Name"></dxi-column>
            <dxi-column cssClass="column-group-sub-header" dataField="isLBUser" caption="Is LB User"></dxi-column>
            <dxi-column cssClass="column-group-sub-header" dataField="apSiteName" caption="Closest AP ASU"></dxi-column>
            <dxi-column cssClass="column-group-sub-header" dataField="apMiles" caption="Closest AP miles"></dxi-column>
            <dxi-column cssClass="column-group-sub-header" dataField="nonCompany"
                caption="Closest NonAP ASU Company"></dxi-column>
            <dxi-column cssClass="column-group-sub-header" dataField="nonSiteName"
                caption="Closest nonAP ASU SiteName"></dxi-column>
            <dxi-column cssClass="column-group-sub-header" dataField="nonmiles"
                caption="Closest NonAP miles"></dxi-column>
        </dx-data-grid>
    </div>
</div>